<span *ngIf="isActionDescInCommentaire(); else actionDescBlock">{{ action.commentaire_action_libre }}</span>
<ng-template #actionDescBlock>{{ action.action_desc }}</ng-template>
